import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import useSessionStorage from "../../hooks/useSessionStorage";
import { useEffect, useState } from "react";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import useConfiguration from "../../hooks/useConfiguration";
import { result } from "lodash";
import './index.css'

const PowerBi = () => {
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const config = useConfiguration();
  const [credentials, setCredentials] = useState({})
  const [accessToken, setAccessToken] = useState('');
  const [embedUrl, setEmbededUrl] = useState('')

  useEffect(() => {
    if (config.baseUrl) {
      getAuthToken();
      //getAuthTokenR1()
    }
  }, [config]);

  useEffect(() => {
    if (Object.keys(credentials).length) {
      getPowerbiToken()
      getPowerBiURL()
    }
  }, [credentials])

  const getAuthToken = async () => {

    var requestOptions = {
      method: 'POST',
      headers: { 'Authorization': login.accessToken ? `Bearer ${login.accessToken}` : '' },
    };

    fetch(`${config.baseUrl}/PowerBI/get-powerbi-access-details`, requestOptions)
      .then(response => response.json())
      .then(result => { setCredentials(result) })
      .catch(error => console.log('error', error));

  }

  const getAuthTokenR1 = async () => {

    var requestOptions = {
      method: 'POST',
      headers: { 'Authorization': login.accessToken ? `Bearer ${login.accessToken}` : '' },
    };

    fetch(`${config.baseUrl}/PowerBI/get-powerbi-access-overturexlreport-details`, requestOptions)
      .then(response => response.json())
      .then(result => { setCredentials(result) })
      .catch(error => console.log('error', error));

  }

  const getPowerbiToken = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${credentials?.accessToken}`);

    var raw = JSON.stringify({
      "accessLevel": "View",
      "datasetId": "3a4e0453-7bf9-4aa0-a8ba-ff7adbbe7657"
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(`https://api.powerbi.com/v1.0/myorg/groups/${credentials?.groupId}/reports/${credentials?.reportId}/GenerateToken`, requestOptions)
      .then(response => response.json())
      .then(result => { setAccessToken(result?.token) })
      .catch(error => console.log('error', error));
  }

  const getPowerBiURL = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${credentials?.accessToken}`);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`https://api.powerbi.com/v1.0/myorg/groups/${credentials?.groupId}/reports/${credentials?.reportId}`, requestOptions)
      .then(response => response.json())
      .then(result => { setEmbededUrl(result?.embedUrl) })
      .catch(error => console.log('error', error));
  }

  //console.log(`${embedUrl}&filter=FinalDBQueryForReport/EmployerUniqueId eq '${login?.employerUniqueId}'`);
  //console.log(login?.employerUniqueId);

  return (
    <>
      <div className="page main-margin">
        <Header />
        <Sidebar />
        <div className="page-main">
          <div className="main-content app-content mt-0 main-background">
            <div className="side-app">
              <div className="main-container container-fluid">
                <div className="page-header">
                  <h1 className="page-title">Reporting Dashboard</h1>
                </div>
                <div className="">
                  {embedUrl && <PowerBIEmbed
                    embedConfig={
                      {
                        type: 'report', // Supported types: report, dashboard, tile, visual, and qna.
                        id: credentials?.reportId,
                        embedUrl: `${embedUrl}&filter=FinalDBQueryForReport/EmployerUniqueId eq '${login?.employerUniqueId}'`,
                        accessToken: accessToken,
                        tokenType: models.TokenType.Embed, // Use models.TokenType.Aad if you're embedding for your organization.
                        settings: {
                          panes: {
                            filters: {
                              expanded: false,
                              visible: false
                            }
                          },
                          // layoutType: models.LayoutType.Custom,
                          // customLayout: {
                          //   displayOption: models.DisplayOption.FitToPage
                          // }
                        }
                      }
                    }

                    eventHandlers={
                      new Map([
                        ['loaded', function () {
                          console.log('Report loaded');
                        }],
                        ['rendered', function () {
                          console.log('Report rendered');
                        }],
                        ['error', function (event) {
                          console.log(event.detail);
                        }]
                      ])
                    }

                    cssClassName={
                      "report-style-class"
                    }

                    getEmbeddedComponent={
                      (embeddedReport) => {
                        window.report = embeddedReport;
                      }
                    }
                  />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PowerBi;
